import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { useBiAction } from '../BiTracking';
import styles from './RadioButton.module.scss';
export const RadioButton = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className, children, name, value, checked, onChange, id, disabled, testId, bi, noBi: _noBi } = props, rest = _object_without_properties(props, [
        "className",
        "children",
        "name",
        "value",
        "checked",
        "onChange",
        "id",
        "disabled",
        "testId",
        "bi",
        "noBi"
    ]);
    const [isChecked, setIsChecked] = useState(false);
    const logBiAction = useBiAction();
    useEffect(()=>{
        setIsChecked(!!checked);
    }, [
        checked
    ]);
    return /*#__PURE__*/ _jsxs("label", _object_spread_props(_object_spread({
        ref: ref,
        "aria-disabled": disabled,
        "aria-checked": isChecked,
        className: cn(styles.root, className),
        "data-testid": testId
    }, rest), {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.radioButton,
                tabIndex: 0,
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        className: styles.nativeRadio,
                        "data-testid": testId && "".concat(testId, "-input"),
                        type: "radio",
                        value: value,
                        disabled: disabled,
                        name: name,
                        id: id,
                        checked: onChange || checked ? isChecked : undefined,
                        onChange: (e)=>{
                            if (bi === null || bi === void 0 ? void 0 : bi.name) {
                                logBiAction({
                                    entityType: 'radio_button',
                                    entityName: bi.name,
                                    actionType: 'select',
                                    data: _object_spread_props(_object_spread({}, bi.data), {
                                        test_id: testId !== null && testId !== void 0 ? testId : ''
                                    })
                                });
                            }
                            if (onChange) {
                                //controlled
                                e.persist();
                                onChange(e);
                            } else {
                                //uncontrolled
                                setIsChecked(e.target.checked);
                            }
                        },
                        tabIndex: -1
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.checkmark
                    })
                ]
            }),
            children
        ]
    }));
});
RadioButton.displayName = 'RadioButton';
